import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import { apiCallStatus } from 'helpers/constants';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { formatDateTime } from 'helpers/dateTimeFormatter';
import colors from 'theme/_colors.scss';
import { requestType } from './constants';
import './style.scss';

const ActivateDeactivateGatewayComponent = ({ model, actions, show, close, gatewayID }) => {
    const { t: translate } = useTranslation();

    const { lastCommandStatusActivateRemoteConnection, activateDeactivateGateway } = actions;
    const { lastCommandStatus, lastCommandStatusLoadingStatus } = model;

    const getLastCommandStatusRequestTime = () => {
        if (!lastCommandStatus?.data?.requestType) {
            return '-';
        }
        return formatDateTime(lastCommandStatus?.data?.requestTime);
    };

    const getActivationDeactivationLabel = () => {
        if (!lastCommandStatus?.data?.requestType) {
            return '-';
        }

        if (lastCommandStatus?.data?.requestType === requestType.DEACTIVATED_REMOTE_CONNECTION) {
            return translate('ABB.Powertrain.Frontend.gatewayRemoteConnectionsDeactivationLabel');
        } else {
            return translate('ABB.Powertrain.Frontend.gatewayRemoteConnectionsActivationLabel');
        }
    };

    useEffect(() => {
        if (gatewayID) {
            lastCommandStatusActivateRemoteConnection(gatewayID, requestType.ACTIVATED_REMOTE_CONNECTION);
        }
    }, [gatewayID, lastCommandStatusActivateRemoteConnection]);

    const datacollectionUnitID = gatewayID;
    const content = <div className='activate-deactivate-gateway__content'>
        <div>{translate('ABB.Powertrain.Frontend.gatewayRemoteConnectionDeactivatedDescription')}</div>
        <div className='activate-deactivate-gateway__loading-status'>
            <LoadingStatusWrapper loadingStatus={lastCommandStatusLoadingStatus} indicatorConfig={{ size: 'small', style: { 'padding': '8px 0px' } }}
                transparent>
                {
                    lastCommandStatusLoadingStatus === apiCallStatus.SUCCESS ?
                        <div>{translate('ABB.Powertrain.Frontend.gatewayRemoteConnectionsLastActionLabel')}: {getActivationDeactivationLabel()}, {getLastCommandStatusRequestTime()}</div> : null
                }
            </LoadingStatusWrapper>
        </div>
    </div>;

    const getRefreshGatewayTitle = <h1 className='activate-deactivate-gateway__title'>
        <IconInfoFilled color={colors.primaryInfo} />
        <span className='activate-deactivate-gateway__title-text'>{translate('ABB.Powertrain.Frontend.gatewayRemoteConnectionDeactivateTitle')}</span>
    </h1>;
    return <GeneralDialog
        show={show}
        close={close}
        title={getRefreshGatewayTitle}
        dialogClassName='activate-deactivate-gateway__dialog'
        closeButton={true}
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.cancelLabel'),
        }}
        acceptButtonProps={{
            text: translate('ABB.Powertrain.Frontend.gatewayRemoteConnectionsDeactivateButtonLabel'),
            onClick: () => {
                activateDeactivateGateway(gatewayID, datacollectionUnitID, false);
                close();
            }
        }}
    >
        {content}
    </GeneralDialog>;
};

ActivateDeactivateGatewayComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    gatewayID: PropTypes.string,
    model: PropTypes.shape({
        lastCommandStatus: PropTypes.object,
        lastCommandStatusLoadingStatus: PropTypes.string,
    }),
    actions: PropTypes.shape({
        lastCommandStatusActivateRemoteConnection: PropTypes.func,
        activateDeactivateGateway: PropTypes.func,
    })
};

export default ActivateDeactivateGatewayComponent;
